/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { HeaderText } from './models/header-text.interface';

@Component({
  selector: 'tmo-header-text',
  templateUrl: './header-text.component.html',
  styleUrls: ['./header-text.component.scss'],
})
export class HeaderTextComponent
  extends AuthorableComponent<HeaderText>
  implements OnInit, OnDestroy
{
  @Input() public html: string;
  @Input() public css: string;
  @Input() public headerText: string;

  constructor() {
    super();
    this.html = '';
    this.css = '';
    this.headerText = '';
  }
  public ngOnInit(): void {}

  public setData(data: HeaderText): void {
    if (this.validate(data)) {
      this.html = data.html;
      if (data.css) {
        this.css = data.css;
      }
    }
  }

  public validate(data: HeaderText): boolean {
    return true;
  }

  public ngOnDestroy(): void {}
}
